module.exports = __webpack_public_path__ + "img/home-header-mobile.e5b752a3.jpg";